module.exports = __webpack_public_path__ + "img/bus_placeholder.42641278.svg";